import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material';
import { useMemo } from 'react';
import {
  configurationV21SelectMenuProps,
  parseCommaSeparatedValues,
  parseConfigurationValuesList,
} from './configurationV21ListFieldUtils';

interface ConfigurationCommaSeparatedMultiSelectV21Props {
  handleValueChange: (val: string) => void;
  controlerValue: string;
  valuesList: string;
}

export const ConfigurationCommaSeparatedMultiSelectV21: React.FC<
  ConfigurationCommaSeparatedMultiSelectV21Props
> = ({ handleValueChange, controlerValue, valuesList }) => {
  const dropdownValuesList = useMemo(
    () => parseConfigurationValuesList(valuesList),
    [valuesList]
  );
  const selectedValues = useMemo(
    () => parseCommaSeparatedValues(controlerValue),
    [controlerValue]
  );

  return (
    <Select
      multiple
      value={selectedValues}
      onChange={(e) => {
        const next = e.target.value as string[];
        handleValueChange(next.join(','));
      }}
      renderValue={(selected) => {
        if (!selected.length) {
          return '-';
        }
        return selected.join(', ');
      }}
      fullWidth
      MenuProps={configurationV21SelectMenuProps}
      sx={{
        minWidth: 0,
        maxWidth: '100%',
        '& .MuiSelect-select': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      {dropdownValuesList.map((listItemValue) => (
        <MenuItem key={listItemValue} value={listItemValue}>
          <Checkbox checked={selectedValues.includes(listItemValue)} />
          <ListItemText primary={listItemValue} />
        </MenuItem>
      ))}
    </Select>
  );
};
